import { h } from "preact";

import classname from "../../../../foundation/utils/classname";

import styles from "./RightPanelBasicComponentLabel.module.css";

enum Variant {
    NoLinked = "noLinked",
    StyleguideLinked = "styleguideLinked",
    StorybookLinked = "storybookLinked",
    BrokenLink = "brokenLink"
}

interface Props {
    class?: string;
    text: string;
    variant: Variant;
}

// TODO-electron-tech-debt-ozge: Replace this component after ComponentLabel component is implemented
function RightPanelBasicComponentLabel({
    class: cssClass,
    text,
    variant
}: Props) {
    return (
        <span
            class={classname(
                "caption-1 medium",
                styles.rightPanelBasicComponentLabel,
                cssClass,
                styles[variant]
            )}>
            {text}
        </span>
    );
}

export default RightPanelBasicComponentLabel;
export {
    Variant as ComponentLabelVariant
};
